import queryString from 'query-string';
import { combineReducers } from 'redux';
import { all, put } from 'redux-saga/effects';

import { stripeOnboarding } from './bankingInformation/data/actions';
import bankingInformationReducer from './bankingInformation/data/reducer';
import bankingInformationSaga from './bankingInformation/data/sagas';
import chargeReceiptsReducer from './chargeReceipts/data/reducer';
import chargeReceiptsSaga from './chargeReceipts/data/sagas';
import defaultTaxRateReducer from './defaultTaxRate/data/reducer';
import defaultTaxRateSaga from './defaultTaxRate/data/sagas';

const initSaga = function* () {
  if (window.location.search) {
    const stripeStatus = queryString.parse(
      window.location.search,
    ).stripe_status;
    if (stripeStatus == 'success') {
      yield put(stripeOnboarding.success());
    } else if (stripeStatus == 'failure')
      yield put(
        stripeOnboarding.error(new Error('Unable to create Stripe account.')),
      );
  }
};

const reducer = combineReducers({
  bankingInformation: bankingInformationReducer,
  chargeReceipts: chargeReceiptsReducer,
  defaultTaxRate: defaultTaxRateReducer,
});

const saga = function* () {
  yield all([
    bankingInformationSaga(),
    chargeReceiptsSaga(),
    defaultTaxRateSaga(),
  ]);
};

export { initSaga, reducer, saga };
